import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEEnvironmentalCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Environmental Engineering",
    shortName: "B.E. Environmental",
    duration: "4 years",
    description: "Engineering program focused on environmental protection, pollution control, and sustainable development solutions",
    overview: "Bachelor of Engineering in Environmental Engineering (B.E. Environmental) is a 4-year undergraduate program that combines engineering principles with environmental science to address pollution control, waste management, water treatment, and sustainable development. This course prepares students to design solutions for environmental challenges and promote eco-friendly technologies.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in environmental sciences and sustainability"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Environmental Science",
          "Engineering Graphics",
          "Basic Civil Engineering"
        ]
      },
      {
        year: 2,
        subjects: [
          "Fluid Mechanics",
          "Environmental Chemistry",
          "Microbiology",
          "Thermodynamics",
          "Strength of Materials",
          "Surveying"
        ]
      },
      {
        year: 3,
        subjects: [
          "Water Treatment Engineering",
          "Air Pollution Control",
          "Solid Waste Management",
          "Environmental Impact Assessment",
          "Wastewater Treatment",
          "Hazardous Waste Management"
        ]
      },
      {
        year: 4,
        subjects: [
          "Environmental Modeling",
          "Green Building Technology",
          "Renewable Energy Systems",
          "Environmental Law and Policy",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Environmental Engineer",
        "Pollution Control Officer",
        "Environmental Consultant",
        "Water Treatment Engineer",
        "EIA Specialist",
        "Sustainability Manager",
        "Waste Management Engineer",
        "Environmental Auditor"
      ],
      industries: [
        "Environmental Consulting Firms",
        "Water Treatment Plants",
        "Government Environmental Agencies",
        "Manufacturing Industries",
        "Construction Companies",
        "Research Institutions",
        "NGOs and International Organizations",
        "Renewable Energy Companies"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-25 LPA (Experienced)",
      topRecruiters: [
        "TNPCB, CPCB",
        "L&T, Tata Projects",
        "VA Tech Wabag",
        "Ramky Enviro",
        "ERM, AECOM",
        "Thermax, Ion Exchange"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Thiagarajar College of Engineering",
        location: "Madurai",
        fees: "₹3,20,000",
        ranking: "NIRF Ranking: 78"
      },
      {
        name: "Government College of Technology",
        location: "Coimbatore",
        fees: "₹1,50,000",
        ranking: "NAAC A Grade"
      }
    ],

    skills: [
      "Environmental Impact Assessment",
      "Water and Wastewater Treatment",
      "Air Quality Monitoring",
      "Environmental Modeling Software",
      "Pollution Control Technologies",
      "Waste Management Systems",
      "Environmental Auditing",
      "Regulatory Compliance",
      "Sustainability Assessment",
      "Technical Report Writing"
    ],

    futureScope: "Growing demand due to increasing environmental awareness, stricter regulations, and focus on sustainable development with opportunities in green technology and climate change mitigation.",

    faqs: [
      {
        question: "What is the difference between Environmental Engineering and Environmental Science?",
        answer: "Environmental Engineering focuses on designing technical solutions to environmental problems, while Environmental Science is more research-oriented and studies environmental systems."
      },
      {
        question: "Are there good job opportunities in government sector?",
        answer: "Yes, excellent opportunities in Pollution Control Boards, Municipal Corporations, and environmental ministries with job security and good growth prospects."
      },
      {
        question: "Can I work in private companies?",
        answer: "Absolutely! Many industries need environmental engineers for compliance, waste management, and implementing green technologies."
      },
      {
        question: "What are the higher study options?",
        answer: "M.E./M.Tech in Environmental Engineering, MBA in Sustainability, or specialized certifications in environmental management systems."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEEnvironmentalCoursePage;
